import React from 'react';
import {
    VertModal,
    VertButton,
    Typography,
    notification
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import FileIcon from '../Icons/file';
import dayjs from 'dayjs';
import { convertNumberToStringCurrency } from 'Utils/convertPoints';
import { useDispatch } from 'react-redux';
import { resetConvertedPriceData } from 'redux/Reducers/Concierge/getConvertedPriceSlice';
import { resetDataValidateBarCode } from 'redux/Reducers/Concierge/validateBarCodeSlicer';

const ConfirmDetailsPaymentModal = ({ isOpen, onClose, confirmDetailsPayment, addBillPayment, form }) => {

    const dispatch = useDispatch();

    const handleAddBillPayment = () => {
        addBillPayment(confirmDetailsPayment);

        dispatch(resetConvertedPriceData());
        dispatch(resetDataValidateBarCode());

        form.resetFields();

        notification.success({
            message: "Pagamento de conta adicionado com sucesso.",
        });
    }

    return (
        <VertModal
            width={'25%'}
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => onClose()}
            className="modal-confirm-details-payment"
            closable={false}
        >

            <Row gutter={[16, 16]}>

                <Col span={24}>

                    <Row justify={'center'}>

                        <Col>
                            <FileIcon />
                        </Col>

                    </Row>

                </Col>

                <Col span={24} className='container-confirm-details-payment'>
                    <Typography.Text className='confirm-details-payment-text'>
                        Confira os detalhes do seu pagamento
                    </Typography.Text>
                </Col>

                <Col span={24}>

                    <Row justify={'center'}>

                        <Col span={20}>

                            <Row gutter={[8, 8]}>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        Tipo de conta:
                                    </span>
                                </Col>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        {confirmDetailsPayment.subCategoryLabel}
                                    </span>
                                </Col>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        Valor do boleto:
                                    </span>
                                </Col>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        {convertNumberToStringCurrency(confirmDetailsPayment.unitValue)}
                                    </span>
                                </Col>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        Data de vencimento:
                                    </span>
                                </Col>

                                <Col span={12}>
                                    <span className="confirm-details-payment-details">
                                        {dayjs(confirmDetailsPayment.date).format('DD/MM/YYYY')}
                                    </span>
                                </Col>

                            </Row>


                        </Col>

                    </Row>

                </Col>

                <Col span={24}>
                    <Row justify={'center'} gutter={[16, 16]}>
                        <Col span={10}>
                            <VertButton
                                className='button-continue button-concierge button-confirm-details-payment'
                                type='default'
                                size="default"
                                htmlType="button"
                                onClick={() => { onClose() }}
                            >
                                Cancelar
                            </VertButton>
                        </Col>
                        <Col span={10}>
                            <VertButton
                                className='button-continue button-concierge button-confirm-details-payment'
                                type='highlight'
                                size="default"
                                htmlType="button"
                                onClick={handleAddBillPayment}
                            >
                                Confirmar
                            </VertButton>
                        </Col>
                    </Row>
                </Col>

            </Row>

        </VertModal>
    );
};

export default ConfirmDetailsPaymentModal;
